module.exports = __webpack_public_path__ + "img/1.3336d23a.png";